import { makeEnvironmentProviders } from '@angular/core';
import { ErrorHandlingModuleConfig, provideErrorHandling } from '@mri-platform/angular-error-handling';
import { ErrorLoggingModuleConfig, provideErrorLogging } from '@mri-platform/angular-error-logging';
import {
  AngularResourceAuthzConfig,
  provideResourceAuthz,
  ResourceAuthzGuard
} from '@mri-platform/angular-resource-authz';
import { KendoToastErrorAppenderService } from '@mri-platform/kendo-ui-toast-appender';
import { ErrorNotifierService, ResourceAuthzGuardInjectionToken } from '@mri-platform/shared/core';
import { provideWfeProxyOidc } from '@mri/angular-wfe-proxy-oidc';
import { AgSharedConfigProvider } from './app-config/ag-shared-config.provider';
import { AgWidgetConfigProvider } from './app-config/ag-widget-config.provider';
import { ApiConfigProvider } from './app-config/api.config.provider';
import { AskAgoraConfigProvider } from './app-config/ask-agora-insights-config.provider';
import { AskAiFrameConfigProvider } from './app-config/ask-ai-frame-config.provider';
import { AskAiIntelligenceConfigProvider } from './app-config/ask-ai-intelligence-config.provider';
import { FeatureFlagsConfigProvider } from './app-config/feature-flags-config.provider';
import { SettingsProvider } from './app-config/settings.provider';
import { AuthConfigProvider } from './auth/auth-config.provider';
import { DefaultResourceAuthzSessionService } from './auth/default-resource-authz-session.service';
import { OAuthModuleConfigProvider } from './auth/oauth-module-config.provider';
import { ClientVsInitializerProvider } from './version-info/client-vs-initializer.provider';

const defaultResourceAuthzConfig: AngularResourceAuthzConfig = {
  sessionServiceType: DefaultResourceAuthzSessionService
};

export interface AppCoreIntegrationConfig {
  errorHandling?: ErrorHandlingModuleConfig;
  errorLogging?: ErrorLoggingModuleConfig;
  resourceAuthz?: AngularResourceAuthzConfig;
}

export function provideAppCoreIntegration(config?: AppCoreIntegrationConfig) {
  config = config ?? {};
  return makeEnvironmentProviders([
    provideWfeProxyOidc(),
    provideErrorLogging({
      additionalAppenders: [KendoToastErrorAppenderService],
      ...config.errorLogging
    }),
    provideErrorHandling(config.errorHandling),
    provideResourceAuthz(config.resourceAuthz ?? defaultResourceAuthzConfig),
    [
      ApiConfigProvider,
      AskAgoraConfigProvider,
      AskAiFrameConfigProvider,
      AskAiIntelligenceConfigProvider,
      FeatureFlagsConfigProvider,
      SettingsProvider,
      AuthConfigProvider,
      AgWidgetConfigProvider,
      AgSharedConfigProvider,
      { provide: ResourceAuthzGuardInjectionToken, useExisting: ResourceAuthzGuard },
      OAuthModuleConfigProvider,
      ClientVsInitializerProvider,
      { provide: ErrorNotifierService, useExisting: KendoToastErrorAppenderService }
    ]
  ]);
}
